import { render, staticRenderFns } from "./discussBox.vue?vue&type=template&id=21969aa8&scoped=true&"
import script from "./discussBox.vue?vue&type=script&lang=js&"
export * from "./discussBox.vue?vue&type=script&lang=js&"
import style0 from "./discussBox.vue?vue&type=style&index=0&id=21969aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21969aa8",
  null
  
)

component.options.__file = "discussBox.vue"
export default component.exports